// extracted by mini-css-extract-plugin
export var centerAligned = "EAz3ce6m6reI5231g31O";
export var info = "HlRVLbYQzAvowh8bCDza";
export var leftBorder = "tTt7tMmbEUiirqwUIRLy";
export var negative = "XeHjS8vPzqSnCHIjDvgk";
export var neutral = "ZKAmDbXKItC450gd4K_a";
export var positive = "Stp5j3CmkrPpTN7aUO5P";
export var primary = "XelIQJBZP5Jha4A30pBA";
export var root = "KdcMt8Avf0l17T7tAx8u";
export var secondary = "QZGxi_SYqTu2olyr6H6Y";
export var title = "LP3owd6Pd0C4Ok6T2S7R";
export var warning = "TUnJ740PEgNg4zApFNFj";
export var withChevron = "LL23d502E3htt0L8ZvDJ";